import React from "react";

export const NotFound = () => {
  return (
    <main className="center-xy" style={{height:"100vh"}}>
      <h2 className="heading heading-lg">Error: 404</h2>
      <p className="text text-xl">Page Not Found</p>
    </main>
  );
};